import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrong-question-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "filter-panel" }
const _hoisted_5 = { class: "filter-grid" }
const _hoisted_6 = { class: "filter-actions" }
const _hoisted_7 = { class: "rule-text" }
const _hoisted_8 = { class: "button-row" }
const _hoisted_9 = { class: "config-status" }
const _hoisted_10 = {
  key: 0,
  class: "recommend-panel"
}
const _hoisted_11 = { class: "result-panel" }
const _hoisted_12 = { class: "result-head" }
const _hoisted_13 = { class: "result-head-left" }
const _hoisted_14 = {
  key: 1,
  class: "question-list"
}
const _hoisted_15 = { class: "question-main" }
const _hoisted_16 = { class: "question-main-content" }
const _hoisted_17 = { class: "question-title" }
const _hoisted_18 = {
  key: 0,
  class: "metric-row"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  key: 0,
  class: "tag-row"
}
const _hoisted_24 = { class: "media-box" }
const _hoisted_25 = {
  key: 0,
  class: "analysis-box"
}
const _hoisted_26 = {
  key: 1,
  class: "answer-row"
}
const _hoisted_27 = { class: "pagination-wrap" }

import MarkdownContent from "@/components/MarkdownContent.vue";
import { computed, onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import { getClassesApi } from "@/servers/api/classes";
import { getSchoolApi, getWrongQuestionStatConfigApi, putWrongQuestionStatConfigApi } from "@/servers/api/school";
import { getStudentApi } from "@/servers/api/student";
import { getTestPaper as getTestPaperApi } from "@/servers/api/tp";
import {
  getTeacherWrongQuestionRecommend as getTeacherWrongQuestionRecommendApi,
  getTeacherWrongQuestionSearch as searchTeacherWrongQuestionApi,
} from "@/servers/api/wrongQuestion";
import { postCartList } from "@/servers/api/cart";
import { useWrongQuestionCart } from "@/composables/useWrongQuestionCart";
import { apiErrorMessage } from "@/utils/apiError";
import { flattenQuestionGroups } from "@/utils/wrongQuestion";
import { useUserStore } from "@/store";
import WrongQuestionCartDrawer from "./components/WrongQuestionCartDrawer.vue";

type Option = { label: string; value: string | number };
type CountItem = { name: string; count: number };
type WrongQuestionRecord = {
  exam_id?: number | string;
  exam_name?: string;
  paper_id?: number | string;
  class_id?: string;
  student_id?: string;
  student_name?: string;
  question_number?: string;
  is_context?: boolean;
  sub_questions?: WrongQuestionRecord[];
  quick_answer?: string;
  subject?: string;
  question_type?: string;
  keywords?: string[] | string;
  content: string;
  answer?: string;
  question_id?: number | string;
  id?: number | string;
  test_question_id?: number | string;
  score?: number | string;
  full_score?: number | string;
  wrong_count?: number | string;
  participant_count?: number | string;
  wrong_rate?: number | string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherWrongQuestion',
  setup(__props) {

const userStore = useUserStore();
const { cartCount, incrementCount, fetchCartCount } = useWrongQuestionCart();
const mode = ref<"class" | "student">("class");
const cartDrawerOpen = ref(false);
const classCartItems = ref<WrongQuestionRecord[]>([]);
const selectedQuestionKeys = ref<Set<string>>(new Set());
const addingToCart = ref(false);
const rows = ref<WrongQuestionRecord[]>([]);
const loading = ref(false);
const schoolLoading = ref(false);
const optionLoading = ref(false);
const paperLoading = ref(false);
const studentLoading = ref(false);
const recommendLoading = ref(false);
const errorText = ref("");
const allClasses = ref<Array<Option & { grade: string }>>([]);
const gradeOptions = ref<Option[]>([]);
const classOptions = ref<Option[]>([]);
const paperOptions = ref<Array<Option & { exam_id: number }>>([]);
const studentOptions = ref<Option[]>([]);
const recommendKnowledge = ref<CountItem[]>([]);
const recommendTypes = ref<CountItem[]>([]);
const schoolList = ref<any[]>([]);
const filters = reactive({
  subject: undefined as string | undefined,
  school_id: undefined as string | undefined,
  grade: undefined as string | undefined,
  class_id: undefined as string | undefined,
  test_paper_id: undefined as number | undefined,
  student_id: undefined as string | undefined,
  question_type: "",
  knowledge_keyword: "",
});

const pagination = reactive({ page: 1, size: 5, total: 0, matchedTotal: 0 });
const selectableRows = computed(() => rows.value.filter((record) => !record.is_context));
const statScope = ref<"school_default" | "all_students" | "top_10" | "top_20" | "custom">("all_students");
const customTopN = ref<number | null>(null);
const wrongRateFilters = reactive<{ min: number | null; max: number | null }>({ min: null, max: null });
const statConfigOpen = ref(false);
const statConfigSaving = ref(false);
const statConfigLoading = ref(false);
const schoolConfigTopN = ref<number | null>(null);
const schoolConfigConfigured = ref(false);
const statConfigTopN = ref<"all_students" | "custom">("all_students");
const statConfigCustomTopN = ref<number | null>(null);

const statScopeOptions: Option[] = [
  { label: "全部错题", value: "all_students" },
  { label: "错误率最高的 10 道题", value: "top_10" },
  { label: "错误率最高的 20 道题", value: "top_20" },
  { label: "错误率最高的 N 道题", value: "custom" },
];
const statConfigOptions: Option[] = [
  { label: "全班统计", value: "all_students" },
  { label: "前 N 名", value: "custom" },
];

const subjectOptions: Option[] = ["语文", "数学", "英语", "物理", "化学", "生物", "政治", "历史", "地理"].map((item) => ({
  label: item,
  value: item,
}));

const questionTypeOptions: Option[] = ["单选题", "多选题", "填空题", "解答题", "实验题", "计算题"].map((item) => ({
  label: item,
  value: item,
}));

const canChooseClass = computed(() => Boolean(filters.subject && filters.school_id && filters.grade));
const canChoosePaper = computed(() => Boolean(filters.subject && filters.school_id && filters.grade && filters.class_id));
const ruleText = computed(() =>
  mode.value === "class"
    ? "筛选班级错题前，需要先确定科目、学校、年级、班级和试卷；可直接把列表错题加入购物车。"
    : "先用学校、年级、班级定位学生，再选择科目和试卷查看个人错题。"
);
const displayedCartCount = computed(() => (mode.value === "class" ? classCartItems.value.length : cartCount.value));
const schoolConfigText = computed(() => {
  if (statConfigLoading.value) return "加载中";
  if (!schoolConfigConfigured.value || schoolConfigTopN.value === null) return "全班统计";
  return `前 ${schoolConfigTopN.value} 名`;
});

const text = (value: unknown) => String(value ?? "").trim();
const normalizeGradeForApi = (value: unknown) => {
  const grade = text(value);
  if (!grade) return undefined;
  return grade.endsWith("级") || !/^\d{4}$/.test(grade) ? grade : `${grade}级`;
};
const filterOption = (input: string, option: any) => text(option?.label).toLowerCase().includes(input.toLowerCase());
const sortOptions = (a: Option, b: Option) => String(a.label).localeCompare(String(b.label), "zh-Hans-CN", { numeric: true });
const schoolOptions = computed(() =>
  schoolList.value
    .map((item: any) => {
      const value = text(item.school_id || item.id);
      return {
        label: text(item.name || item.school_name || item.school) || value,
        value,
      };
    })
    .filter((item: Option) => item.value)
    .sort(sortOptions)
);

const getLocalSchoolId = () => {
  const user = userStore.getUserInfo();
  return text(user?.teacher?.school_id || user?.school_id || user?.teacher?.school);
};

//加载学校列表
const loadSchools = async () => {
  schoolLoading.value = true;
  try {
    const res = await getSchoolApi({ page: 1, size: 1000 } as any);
    const data = Array.isArray(res?.data) ? res.data : Array.isArray(res?.data?.records) ? res.data.records : [];
    schoolList.value = data;
  } catch {
    message.error("学校列表加载失败");
  } finally {
    schoolLoading.value = false;
  }
};

const loadSchoolStatConfig = async (schoolId?: string) => {
  const id = text(schoolId);
  if (!id) {
    schoolConfigTopN.value = null;
    schoolConfigConfigured.value = false;
    return;
  }
  if (statConfigLoading.value) return;
  statConfigLoading.value = true;
  try {
    const res = await getWrongQuestionStatConfigApi({ school_id: id });
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "配置加载失败");
    const data = res?.data || {};
    schoolConfigTopN.value = data.top_n === null || data.top_n === undefined ? null : Number(data.top_n);
    schoolConfigConfigured.value = Boolean(data.configured);
  } catch (error: any) {
    schoolConfigTopN.value = null;
    schoolConfigConfigured.value = false;
    message.error(error?.message || "学校统计配置加载失败");
  } finally {
    statConfigLoading.value = false;
  }
};

const openStatConfig = () => {
  if (!text(filters.school_id)) return;
  statConfigTopN.value = schoolConfigConfigured.value && schoolConfigTopN.value !== null ? "custom" : "all_students";
  statConfigCustomTopN.value = schoolConfigTopN.value;
  statConfigOpen.value = true;
};

const saveStatConfig = async () => {
  const schoolId = text(filters.school_id);
  if (!schoolId) return;
  const topN = statConfigTopN.value === "all_students" ? null : statConfigCustomTopN.value;
  if (topN !== null && (!Number.isInteger(topN) || topN < 1 || topN > 1000)) {
    message.error("自定义统计范围必须是 1 到 1000 的整数。");
    return;
  }
  statConfigSaving.value = true;
  try {
    const res = await putWrongQuestionStatConfigApi({ school_id: schoolId }, { top_n: topN });
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "配置保存失败");
    const data = res?.data || { top_n: topN, configured: topN !== null };
    schoolConfigTopN.value = data.top_n === null || data.top_n === undefined ? null : Number(data.top_n);
    schoolConfigConfigured.value = Boolean(data.configured);
    statConfigOpen.value = false;
    message.success("学校统计配置已保存");
  } catch (error: any) {
    message.error(error?.message || "学校统计配置保存失败");
  } finally {
    statConfigSaving.value = false;
  }
};

const buildBaseParams = (): API.getTeacherWrongQuestionSearchParams => ({
  page: pagination.page,
  size: pagination.size,
  subject: filters.subject,
  school_id: text(filters.school_id),
  grade: normalizeGradeForApi(filters.grade),
  class_id: text(filters.class_id),
  test_paper_id: filters.test_paper_id,
  exam_id: paperOptions.value.find((paper) => paper.value === filters.test_paper_id)?.exam_id || undefined,
  student_id: mode.value === "student" ? filters.student_id : undefined,
  question_type: text(filters.question_type) || undefined,
  knowledge_keyword: text(filters.knowledge_keyword) || undefined,
});

const buildParams = (): API.getTeacherWrongQuestionSearchParams => {
  const params = buildBaseParams();
  if (mode.value === "class") {
    if (wrongRateFilters.min !== null) params.min_wrong_rate = wrongRateFilters.min / 100;
    if (wrongRateFilters.max !== null) params.max_wrong_rate = wrongRateFilters.max / 100;
    if (statScope.value === "all_students") params.top_n = 0;
    else if (statScope.value === "top_10") params.top_n = 10;
    else if (statScope.value === "top_20") params.top_n = 20;
    else if (statScope.value === "custom") params.top_n = customTopN.value ?? undefined;
  }
  return params;
};

const refreshClassOptions = () => {
  const grade = text(filters.grade);
  classOptions.value = allClasses.value
    .filter((item) => !grade || item.grade === grade)
    .map(({ label, value }) => ({ label, value }))
    .sort(sortOptions);
};

const loadClasses = async () => {
  if (!text(filters.school_id)) return;
  optionLoading.value = true;
  try {
    const res = await getClassesApi({ school_id: filters.school_id, page: 1, size: 1000 } as any);
    const data = Array.isArray(res?.data) ? res.data : [];
    allClasses.value = data
      .map((item: any) => {
        const value = text(item.id || item.class_id);
        return {
          label: text(item.name) || `班级 ${value}`,
          value,
          grade: text(item.grade),
        };
      })
      .filter((item: any) => item.value);
    const gradeMap = new Map<string, string>();
    allClasses.value.forEach((item) => {
      if (item.grade) gradeMap.set(item.grade, item.grade);
    });
    gradeOptions.value = Array.from(gradeMap.entries()).map(([value, label]) => ({ label, value })).sort(sortOptions);
    refreshClassOptions();
  } catch {
    message.error("班级列表加载失败");
  } finally {
    optionLoading.value = false;
  }
};

const loadPapers = async () => {
  if (!canChoosePaper.value) return;
  paperLoading.value = true;
  try {
    const res = await getTestPaperApi({
      page: 1,
      size: 1000,
      school_id: text(filters.school_id),
      grade: normalizeGradeForApi(filters.grade),
      subject: filters.subject,
    } as any);
    const data = Array.isArray(res?.data) ? res.data : [];
    paperOptions.value = data
      .map((item: any) => ({
        label: text(item.name) || text(item.paper_name) || `试卷 ${item.id || item.paper_id}`,
        value: Number(item.id || item.paper_id),
        exam_id: Number(item.exam_id),
      }))
      .filter((item: Option) => Number.isFinite(Number(item.value)))
      .sort(sortOptions);
  } catch {
    message.error("试卷列表加载失败");
  } finally {
    paperLoading.value = false;
  }
};

const loadStudents = async () => {
  if (!filters.class_id) return;
  studentLoading.value = true;
  try {
    const res = await getStudentApi({ school: filters.school_id, grade: normalizeGradeForApi(filters.grade), class_id: text(filters.class_id), page: 1, size: 1000 } as any);
    const data = Array.isArray(res?.data) ? res.data : [];
    studentOptions.value = data
      .map((item: any) => ({
        label: `${text(item.name) || "学生"} ${text(item.uid)}`,
        value: text(item.uid),
      }))
      .filter((item: Option) => item.value)
      .sort(sortOptions);
  } catch {
    message.error("学生列表加载失败");
  } finally {
    studentLoading.value = false;
  }
};

const validateSearch = () => {
  const min = wrongRateFilters.min;
  const max = wrongRateFilters.max;
  if (mode.value === "class") {
    if (min !== null && (!Number.isFinite(min) || min < 0 || min > 100)) {
      errorText.value = "最低错误率必须位于 0% 到 100% 之间。";
      return false;
    }
    if (max !== null && (!Number.isFinite(max) || max < 0 || max > 100)) {
      errorText.value = "最高错误率必须位于 0% 到 100% 之间。";
      return false;
    }
    if (min !== null && max !== null && min > max) {
      errorText.value = "最低错误率不能高于最高错误率。";
      return false;
    }
    if (statScope.value === "custom" && (!Number.isInteger(customTopN.value) || customTopN.value! < 1 || customTopN.value! > 1000)) {
      errorText.value = "自定义统计范围必须是 1 到 1000 的整数。";
      return false;
    }
  }
  if (!filters.subject || !text(filters.school_id) || !filters.grade) {
    errorText.value = "请先选择科目、学校和年级。";
    return false;
  }
  if (!filters.class_id) {
    errorText.value = "请先选择班级，再查询错题。";
    return false;
  }
  if (mode.value === "student" && !filters.student_id) {
    errorText.value = "学生错题模式需要先选择班级和学生。";
    return false;
  }
  // 试卷可不选：不选则汇总该班级全部考试的错题（后端已支持 exam_id/test_paper_id 可选）。
  errorText.value = "";
  return true;
};

const search = async (resetPage = false) => {
  if (resetPage) pagination.page = 1;
  if (!validateSearch()) {
    rows.value = [];
    pagination.total = 0;
    pagination.matchedTotal = 0;
    return;
  }
  loading.value = true;
  try {
    const res = await searchTeacherWrongQuestionApi(buildParams());
    if (Number(res?.code) !== 200) throw new Error(apiErrorMessage(res, "查询失败"));
    rows.value = flattenQuestionGroups<WrongQuestionRecord>(Array.isArray(res?.data) ? res.data : []);
    selectedQuestionKeys.value = new Set();
    pagination.total = Number(res?.total ?? 0);
    pagination.matchedTotal = Number(res?.matched_total ?? 0);
    if (mode.value === "student" && filters.student_id) {
      fetchCartCount(filters.student_id);
    }
  } catch (error: any) {
    rows.value = [];
    pagination.total = 0;
    pagination.matchedTotal = 0;
    errorText.value = error?.message || "查询错题失败";
  } finally {
    loading.value = false;
  }
};

const loadRecommend = async () => {
  if (!validateSearch()) return;
  recommendLoading.value = true;
  try {
    const res = await getTeacherWrongQuestionRecommendApi({
      subject: filters.subject,
      school_id: text(filters.school_id),
      grade: normalizeGradeForApi(filters.grade),
      class_id: text(filters.class_id),
      test_paper_id: filters.test_paper_id,
      student_id: mode.value === "student" ? filters.student_id : undefined,
      question_type: text(filters.question_type) || undefined,
      knowledge_keyword: text(filters.knowledge_keyword) || undefined,
      limit: 12,
    });
    if (Number(res?.code) !== 200) throw new Error(apiErrorMessage(res, "推荐失败"));
    recommendKnowledge.value = Array.isArray(res?.data?.knowledge_points) ? res.data.knowledge_points : [];
    recommendTypes.value = Array.isArray(res?.data?.question_types) ? res.data.question_types : [];
  } catch (error: any) {
    message.error(error?.message || "推荐加载失败");
  } finally {
    recommendLoading.value = false;
  }
};

const handleSearch = () => { selectedQuestionKeys.value = new Set(); search(true); };
const clearQueryResult = () => {
  rows.value = [];
  pagination.page = 1;
  pagination.total = 0;
  pagination.matchedTotal = 0;
  recommendKnowledge.value = [];
  recommendTypes.value = [];
};
const resetStatFilters = () => {
  statScope.value = "all_students";
  customTopN.value = null;
  wrongRateFilters.min = null;
  wrongRateFilters.max = null;
};

const handleModeChange = () => {
  filters.student_id = undefined;
  resetStatFilters();
  selectedQuestionKeys.value = new Set();
  if (mode.value === "student") fetchCartCount();
  clearQueryResult();
  if (filters.class_id) {
    loadStudents();
  }
};
const handleBaseChange = async () => {
  filters.class_id = undefined;
  filters.test_paper_id = undefined;
  filters.student_id = undefined;
  filters.question_type = "";
  classOptions.value = [];
  paperOptions.value = [];
  studentOptions.value = [];
  clearQueryResult();
  refreshClassOptions();
};
const handleSchoolChange = async () => {
  resetStatFilters();
  await loadSchoolStatConfig(filters.school_id);
  filters.grade = undefined;
  filters.class_id = undefined;
  filters.test_paper_id = undefined;
  filters.student_id = undefined;
  filters.question_type = "";
  gradeOptions.value = [];
  classOptions.value = [];
  paperOptions.value = [];
  clearQueryResult();
  await loadClasses();
};
const handleGradeChange = async () => {
  filters.class_id = undefined;
  filters.test_paper_id = undefined;
  filters.student_id = undefined;
  filters.question_type = "";
  studentOptions.value = [];
  paperOptions.value = [];
  clearQueryResult();
  refreshClassOptions();
};
const handlePaperChange = async () => {
  filters.question_type = "";
  await search(true);
};
const handleClassChange = async () => {
  filters.test_paper_id = undefined;
  filters.student_id = undefined;
  studentOptions.value = [];
  paperOptions.value = [];
  clearQueryResult();
  if (!filters.class_id) {
    errorText.value = "请先选择班级，再查询错题。";
    return;
  }
  errorText.value = "";
  await loadPapers();
  await loadStudents();
  if (mode.value === "class") await search(true);
};
const handleStudentChange = async () => {
  selectedQuestionKeys.value = new Set();
  await fetchCartCount(filters.student_id);
  if (mode.value === "student") {
    await search(true);
  }
};
const handlePageChange = async (page: number) => {
  pagination.page = page;
  await search(false);
};
const handleSizeChange = async (_page: number, size: number) => {
  pagination.size = size;
  await search(true);
};
const resetFilters = async () => {
  resetStatFilters();
  filters.subject = undefined;
  filters.school_id = getLocalSchoolId();
  filters.grade = undefined;
  filters.class_id = undefined;
  filters.test_paper_id = undefined;
  filters.student_id = undefined;
  filters.question_type = "";
  filters.knowledge_keyword = "";
  rows.value = [];
  pagination.page = 1;
  pagination.total = 0;
  pagination.matchedTotal = 0;
  recommendKnowledge.value = [];
  recommendTypes.value = [];
  paperOptions.value = [];
  await loadClasses();
  await loadSchoolStatConfig(filters.school_id);
};
const useKnowledge = async (name: string) => {
  filters.knowledge_keyword = name;
  await search(true);
};
const useType = async (name: string) => {
  filters.question_type = name;
  await search(true);
};
const stringList = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(text).filter(Boolean);
  const raw = text(value);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.map(text).filter(Boolean);
  } catch {}
  return [raw];
};
const formatScore = (value: unknown) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return Number.isInteger(num) ? String(num) : num.toFixed(2);
};
const formatPercent = (value: unknown) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return `${(num * 100).toFixed(2)}%`;
};
const recordKey = (record: WrongQuestionRecord) =>
  [record.exam_id, record.paper_id, record.class_id, record.student_id, record.question_number].map(text).join("-");

// ===== 购物车相关 =====

const selectAllQuestions = computed({
  get: () => selectableRows.value.length > 0 && selectedQuestionKeys.value.size === selectableRows.value.length,
  set: () => {},
});

const handleSelectAllQuestions = () => {
  if (selectedQuestionKeys.value.size === selectableRows.value.length) {
    selectedQuestionKeys.value = new Set();
  } else {
    selectedQuestionKeys.value = new Set(selectableRows.value.map((r) => recordKey(r)));
  }
};

const toggleQuestionSelection = (record: WrongQuestionRecord) => {
  if (record.is_context) return;
  const key = recordKey(record);
  const next = new Set(selectedQuestionKeys.value);
  if (next.has(key)) {
    next.delete(key);
  } else {
    next.add(key);
  }
  selectedQuestionKeys.value = next;
};

const handleOpenCart = () => {
  if (mode.value === "student" && !filters.student_id) {
    message.warning("请先选择学生，再查看购物车");
    return;
  }
  cartDrawerOpen.value = true;
};

const updateClassCartItems = (items: WrongQuestionRecord[]) => {
  classCartItems.value = items;
};

/** 将选中的错题加入购物车 */
const handleAddToCart = async () => {
  if (!selectedQuestionKeys.value.size) {
    message.warning("请先勾选要加入购物车的题目");
    return;
  }
  if (mode.value === "student" && !filters.student_id) {
    message.warning("请先选择学生，再加入购物车");
    return;
  }
  addingToCart.value = true;
  let added = 0;
  const keys = Array.from(selectedQuestionKeys.value);
  try {
    if (mode.value === "class") {
      const existingKeys = new Set(classCartItems.value.map((item) => String(item.id || item.question_id || item.test_question_id || "")));
      const newItems = keys
        .map((key) => rows.value.find((r) => recordKey(r) === key))
        .filter((record): record is WrongQuestionRecord => Boolean(record))
        .map((record) => ({
          ...record,
          id: recordKey(record),
          test_question_id: String(record.question_id || ""),
          add_cart_time: new Date().toLocaleString("zh-CN"),
        }))
        .filter((item) => !existingKeys.has(String(item.id || item.question_id || item.test_question_id || "")));

      if (newItems.length) {
        classCartItems.value = [...classCartItems.value, ...newItems];
        added = newItems.length;
      }
    } else {
      for (const key of keys) {
        const record = rows.value.find((r) => recordKey(r) === key);
        if (!record) continue;
        try {
          const res = await postCartList({
            student_id: String(filters.student_id || ""),
            test_question_id: String(record.question_id || ""),
            test_paper_id: String(record.paper_id || ""),
          });
          if (Number(res?.code) === 200) added++;
        } catch { /* skip failed */ }
      }
    }
    if (added > 0) {
      if (mode.value === "student") incrementCount(added);
      message.success(`成功添加 ${added} 道错题到购物车`);
      selectedQuestionKeys.value = new Set();
    } else {
      message.warning("添加失败，请稍后重试");
    }
  } catch {
    message.error("添加购物车出错");
  } finally {
    addingToCart.value = false;
  }
};

onMounted(async () => {
  await loadSchools();
  filters.school_id = getLocalSchoolId();
  if (filters.school_id) {
    await loadClasses();
    await loadSchoolStatConfig(filters.school_id);
  }
  fetchCartCount();
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", null, [
        _createElementVNode("h2", null, "错题模块"),
        _createElementVNode("p", null, "按班级或学生查看未得满分的小题，支持题型和关键词继续筛选。")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: !selectedQuestionKeys.value.size,
          loading: addingToCart.value,
          onClick: handleAddToCart
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 加入购物车 (" + _toDisplayString(selectedQuestionKeys.value.size) + ") ", 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_a_radio_group, {
          value: mode.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((mode).value = $event)),
          "button-style": "solid",
          onChange: handleModeChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: "class" }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("班级错题", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "student" }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("学生错题", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_select, {
          value: filters.subject,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filters.subject) = $event)),
          class: "filter-control",
          placeholder: "科目",
          options: _unref(subjectOptions),
          "allow-clear": "",
          onChange: handleBaseChange
        }, null, 8, ["value", "options"]),
        _createVNode(_component_a_select, {
          value: filters.school_id,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((filters.school_id) = $event)),
          class: "filter-control",
          placeholder: "学校",
          options: schoolOptions.value,
          loading: schoolLoading.value,
          "allow-clear": "",
          "show-search": "",
          "filter-option": filterOption,
          onChange: handleSchoolChange
        }, null, 8, ["value", "options", "loading"]),
        _createVNode(_component_a_select, {
          value: filters.grade,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((filters.grade) = $event)),
          class: "filter-control",
          placeholder: "年级",
          options: gradeOptions.value,
          loading: optionLoading.value,
          "allow-clear": "",
          "show-search": "",
          "filter-option": filterOption,
          onChange: handleGradeChange
        }, null, 8, ["value", "options", "loading"]),
        _createVNode(_component_a_select, {
          value: filters.class_id,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((filters.class_id) = $event)),
          class: "filter-control",
          placeholder: canChooseClass.value ? '班级' : '先选科目、学校和年级',
          disabled: !canChooseClass.value,
          options: classOptions.value,
          loading: optionLoading.value,
          "allow-clear": "",
          "show-search": "",
          "filter-option": filterOption,
          onChange: handleClassChange
        }, null, 8, ["value", "placeholder", "disabled", "options", "loading"]),
        _createVNode(_component_a_select, {
          value: filters.test_paper_id,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((filters.test_paper_id) = $event)),
          class: "filter-control",
          placeholder: canChoosePaper.value ? '试卷' : '先选班级',
          disabled: !canChoosePaper.value,
          options: paperOptions.value,
          loading: paperLoading.value,
          "allow-clear": "",
          "show-search": "",
          "filter-option": filterOption,
          onChange: handlePaperChange
        }, null, 8, ["value", "placeholder", "disabled", "options", "loading"]),
        (mode.value === 'student')
          ? (_openBlock(), _createBlock(_component_a_select, {
              key: 0,
              value: filters.student_id,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((filters.student_id) = $event)),
              class: "filter-control",
              placeholder: filters.class_id ? '学生' : '先选班级',
              disabled: !filters.class_id,
              options: studentOptions.value,
              loading: studentLoading.value,
              "allow-clear": "",
              "show-search": "",
              "filter-option": filterOption,
              onChange: handleStudentChange
            }, null, 8, ["value", "placeholder", "disabled", "options", "loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_select, {
          value: filters.question_type,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((filters.question_type) = $event)),
          class: "filter-control",
          placeholder: "题型",
          options: _unref(questionTypeOptions),
          "allow-clear": "",
          "show-search": "",
          "filter-option": filterOption,
          onChange: handleSearch
        }, null, 8, ["value", "options"]),
        _createVNode(_component_a_input, {
          value: filters.knowledge_keyword,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((filters.knowledge_keyword) = $event)),
          class: "filter-control keyword-control",
          placeholder: "关键词",
          "allow-clear": "",
          onPressEnter: handleSearch
        }, null, 8, ["value"]),
        (mode.value === 'class')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_a_select, {
                value: statScope.value,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((statScope).value = $event)),
                class: "filter-control",
                options: statScopeOptions,
                placeholder: "错题数量"
              }, null, 8, ["value"]),
              (statScope.value === 'custom')
                ? (_openBlock(), _createBlock(_component_a_input_number, {
                    key: 0,
                    value: customTopN.value,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((customTopN).value = $event)),
                    class: "filter-control",
                    min: 1,
                    max: 1000,
                    precision: 0,
                    placeholder: "前 N 道题"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_input_number, {
                value: wrongRateFilters.min,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((wrongRateFilters.min) = $event)),
                class: "filter-control",
                min: 0,
                max: 100,
                step: 5,
                "addon-after": "%",
                placeholder: "最低错误率"
              }, null, 8, ["value"]),
              _createVNode(_component_a_input_number, {
                value: wrongRateFilters.max,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((wrongRateFilters.max) = $event)),
                class: "filter-control",
                min: 0,
                max: 100,
                step: 5,
                "addon-after": "%",
                placeholder: "最高错误率"
              }, null, 8, ["value"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(ruleText.value), 1),
        _createElementVNode("div", _hoisted_8, [
          (mode.value === 'class')
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                disabled: !filters.school_id,
                onClick: openStatConfig
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("统计配置", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_badge, {
            count: displayedCartCount.value,
            "overflow-count": 99,
            "show-zero": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                ghost: "",
                onClick: handleOpenCart
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("购物车", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["count"]),
          _createVNode(_component_a_button, {
            type: "primary",
            loading: loading.value,
            onClick: handleSearch
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("查询", -1)
            ]))]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_a_button, {
            loading: recommendLoading.value,
            onClick: loadRecommend
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("错题频次分析", -1)
            ]))]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_a_button, { onClick: resetFilters }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("重置", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      open: statConfigOpen.value,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((statConfigOpen).value = $event)),
      title: "学校错误率统计配置（不影响当前错题查询）",
      "confirm-loading": statConfigSaving.value,
      onOk: saveStatConfig
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "统计范围" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: statConfigTopN.value,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((statConfigTopN).value = $event)),
                  options: statConfigOptions
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (statConfigTopN.value === 'custom')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "前 N 名"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: statConfigCustomTopN.value,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((statConfigCustomTopN).value = $event)),
                      min: 1,
                      max: 1000,
                      precision: 0
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, "当前配置：" + _toDisplayString(schoolConfigText.value), 1)
      ]),
      _: 1
    }, 8, ["open", "confirm-loading"]),
    (recommendKnowledge.value.length || recommendTypes.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendKnowledge.value, (item) => {
            return (_openBlock(), _createBlock(_component_a_tag, {
              key: `k-${item.name}`,
              color: "processing",
              class: "click-tag",
              onClick: ($event: any) => (useKnowledge(item.name))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendTypes.value, (item) => {
            return (_openBlock(), _createBlock(_component_a_tag, {
              key: `t-${item.name}`,
              color: "blue",
              class: "click-tag",
              onClick: ($event: any) => (useType(item.name))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_a_checkbox, {
            checked: selectAllQuestions.value,
            "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((selectAllQuestions).value = $event)),
            indeterminate: selectedQuestionKeys.value.size > 0 && selectedQuestionKeys.value.size < selectableRows.value.length,
            onChange: handleSelectAllQuestions
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" 全选 ", -1)
            ]))]),
            _: 1
          }, 8, ["checked", "indeterminate"]),
          _createElementVNode("h3", null, _toDisplayString(mode.value === "class" ? "班级错题" : "学生错题"), 1)
        ]),
        _createElementVNode("span", null, "共 " + _toDisplayString(pagination.matchedTotal) + " 道错题", 1)
      ]),
      (errorText.value)
        ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 0,
            type: "warning",
            "show-icon": "",
            message: errorText.value,
            class: "state-alert"
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          (!rows.value.length)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 0,
                description: "暂无错题数据"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (record) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: recordKey(record),
                    class: "question-card"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      (!record.is_context)
                        ? (_openBlock(), _createBlock(_component_a_checkbox, {
                            key: 0,
                            checked: selectedQuestionKeys.value.has(recordKey(record)),
                            class: "question-checkbox",
                            onChange: ($event: any) => (toggleQuestionSelection(record))
                          }, null, 8, ["checked", "onChange"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(record.question_number || "-") + " 题", 1),
                          (record.is_context)
                            ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createTextVNode("母题题干", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (record.subject)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 1,
                                color: "blue"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(record.subject), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (record.question_type)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 2,
                                color: "gold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(record.question_type), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (record.class_id)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 3,
                                color: "cyan"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("班级 " + _toDisplayString(record.class_id), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        (!record.is_context)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (mode.value === 'student')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "得分 " + _toDisplayString(formatScore(record.score)) + "/" + _toDisplayString(formatScore(record.full_score)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_20, "错题人数 " + _toDisplayString(record.wrong_count ?? "-"), 1)),
                              (record.participant_count)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "参与 " + _toDisplayString(record.participant_count), 1))
                                : _createCommentVNode("", true),
                              (record.wrong_rate !== undefined && record.wrong_rate !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "错率 " + _toDisplayString(formatPercent(record.wrong_rate)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (stringList(record.keywords).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stringList(record.keywords), (point) => {
                            return (_openBlock(), _createBlock(_component_a_tag, {
                              key: point,
                              color: "geekblue"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(point), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-grid", { 'is-single': record.sub_questions?.length }])
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "box-title" }, "题干", -1)),
                        (record.content)
                          ? (_openBlock(), _createBlock(MarkdownContent, {
                              key: 0,
                              content: record.content,
                              preview: ""
                            }, null, 8, ["content"]))
                          : (_openBlock(), _createBlock(_component_a_empty, {
                              key: 1,
                              description: "暂无题干"
                            }))
                      ]),
                      (!record.sub_questions?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "box-title" }, "解析", -1)),
                            (record.answer)
                              ? (_openBlock(), _createBlock(MarkdownContent, {
                                  key: 0,
                                  content: record.answer,
                                  preview: ""
                                }, null, 8, ["content"]))
                              : (_openBlock(), _createBlock(_component_a_empty, {
                                  key: 1,
                                  description: "暂无解析"
                                }))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (!record.sub_questions?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "box-title" }, "答案", -1)),
                          (record.quick_answer)
                            ? (_openBlock(), _createBlock(MarkdownContent, {
                                key: 0,
                                content: record.quick_answer,
                                preview: ""
                              }, null, 8, ["content"]))
                            : (_openBlock(), _createBlock(_component_a_empty, {
                                key: 1,
                                description: "暂无答案"
                              }))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
        ]),
        _: 1
      }, 8, ["spinning"]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_a_pagination, {
          current: pagination.page,
          "page-size": pagination.size,
          total: pagination.total,
          "show-size-changer": "",
          "show-total": (total) => `共 ${total} 组`,
          onChange: handlePageChange,
          onShowSizeChange: handleSizeChange
        }, null, 8, ["current", "page-size", "total", "show-total"])
      ])
    ]),
    _createVNode(WrongQuestionCartDrawer, {
      open: cartDrawerOpen.value,
      "onUpdate:open": _cache[17] || (_cache[17] = ($event: any) => ((cartDrawerOpen).value = $event)),
      "local-items": mode.value === 'class' ? classCartItems.value : undefined,
      "student-id": mode.value === 'student' ? filters.student_id : undefined,
      "onUpdate:localItems": updateClassCartItems
    }, null, 8, ["open", "local-items", "student-id"])
  ]))
}
}

})